"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roomPatch = exports.room = void 0;
var _normalizr = require("normalizr");
var _schemas = require("../users/schemas");
// export const room = new schema.Entity('rooms', {
//     members: [user],
// });

var room = exports.room = new _normalizr.schema.Entity('rooms');
var roomPatch = exports.roomPatch = new _normalizr.schema.Entity('rooms', {
  targets: [_schemas.user],
  initiator: _schemas.user
});